export const audioMixin = {
   data: ()=>{
      return {
         audioPlaying: -1,
         audioStatus: [],
         playIcon: 'fa-play',
         stopIcon: 'fa-stop'
      }
   },
   methods: {
      audioPlay: function (index) {
         for (var i = 0; i < this.$refs['audio'].length; i++) {
            if (i != index || this.audioIsPlaying(i)) {
               this.audioStop(i);
            }
            else {
               this.$refs['audio'][index].play();
               this.audioStatus[index] = true;
            }
         }

         if (this.audioStatus[index])
            this.audioPlaying = index;
      },
      audioStop: function (index) {
         if (this.$refs['audio'][index]) {
            this.$refs['audio'][index].pause();
            this.$refs['audio'][index].currentTime = 0;
            this.audioStatus[index] = false;
            this.audioPlaying = -1;
         }
      },
      audioIsPlaying: function (index) {
         return  !this.$refs['audio'][index].paused &&
            this.$refs['audio'][index].currentTime > 0 &&
            !this.$refs['audio'][index].ended;
      },
      audioButtonClass: function (index) {
         if (this.audioPlaying != index)
            return this.playIcon;
         else
            return this.stopIcon;
      },
      audioTooltip: function (index) {
         if (this.audioPlaying != index)
            return 'lbl_play';
         else
            return 'lbl_stop';
      }
   }
};


// WEBPACK FOOTER //
// ./src/Banet/mixins/audioMixin.js